import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import SmartAnotation from '../../../SmartAnnotations';
import RectangularBigBtn from '../../../../components2/Buttons/RectangularbigBtn';
import editIcon from '../../../../static/icons/edit_icon_purple_24.svg';
import closecircle from '../../../../static/img/closecircle.svg';

const PreviewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 12px 16px;
  border-bottom: 1px solid #c9c6cc80;
`;
const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;
const EditButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid #7200E0;
  border-radius: 25px;
  cursor: pointer;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #7200E0;
  &:hover { background: #f2f1f380; }
`;
const CloseButton = styled.button`
  padding: 4px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover { opacity: 0.8; }
`;

export default function CommentBankDialog({
  commentBank,
  setCommentBankPreviewDialog,
  showActionButton = false,
  onActionButtonClick = () => {},
  isSystem = false,
  showEditButton = true,
}) {
  const [open, setOpen] = React.useState(true);
  const history = useHistory();
  const handleClose = () => {
    setOpen(false);
    setCommentBankPreviewDialog(false);
  };

  const handleEdit = () => {
    if (commentBank?.id && !showActionButton) {
      handleClose();
      history.push(`/tools/commentbanks/${commentBank.id}`);
    }
  };

  const handleButtonClick = () => {
    onActionButtonClick();
    setCommentBankPreviewDialog(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        PaperProps={{ style: { width: 750 } }}
        sx={{ zIndex: 2147483647 }}
      >
        <PreviewHeader>
          <HeaderActions>
            {showEditButton && commentBank?.id && !showActionButton && !isSystem && (
              <EditButton onClick={handleEdit} type="button">
                <img src={editIcon} alt="Edit" width={16} height={16} />
                <span>Edit</span>
              </EditButton>
            )}
            <CloseButton onClick={handleClose} type="button" aria-label="Close">
              <img src={closecircle} alt="Close" width={20} height={20} />
            </CloseButton>
          </HeaderActions>
        </PreviewHeader>
        <DialogContent>
          <SuggestionsContainer>
            {commentBank?.smartComments?.map((smartComment, innerIndex) => (
              <SmartAnotation
                key={`${innerIndex}`}
                smartAnnotation={smartComment}
                addOption={false}
              />
            ))}
          </SuggestionsContainer>
          {showActionButton && (
            <ActionButtonContainer>
              <RectangularBigBtn text="Import" onClickFn={handleButtonClick} />
            </ActionButtonContainer>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
}

const ActionButtonContainer = styled.div`
  margin-top: 10px;
`;

const SuggestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
